import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AuthTokenService } from 'src/app/core/services/auth-token.service';
import { CartSessionTokenService } from 'src/app/core/services/cart-session-token.service';
import { PublicCardService } from 'src/app/core/services/public-card.service';
import { finalize, take } from 'rxjs/operators';

type NavbarVariant = 'landing' | 'internal';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent {
  @Input() variant: NavbarVariant = 'landing';
  @Input() buttonText: string = 'Entrar';

  constructor(
    private router: Router,
    private authTokenService: AuthTokenService,
    private cartSessionTokenService: CartSessionTokenService,
    private publicCardService: PublicCardService,
  ) {}

  get isLanding(): boolean {
    return this.variant === 'landing';
  }

  get isInternal(): boolean {
    return this.variant === 'internal';
  }

  onActionClick(): void {
    if (!this.isInternal) {
      this.router.navigate(['/login']);
      return;
    }

    const wasPlayer = this.authTokenService.isPlayerAllowed();
    const finalizeLogout = () => {
      this.cartSessionTokenService.clear();
      this.authTokenService.clear();

      this.router.navigate(['/login'], {
        queryParams: wasPlayer ? { player: 'true' } : undefined,
      });
    };

    if (!this.cartSessionTokenService.has()) {
      finalizeLogout();
      return;
    }

    this.publicCardService
      .cartSessionUserLogout()
      .pipe(
        take(1),
        finalize(() => finalizeLogout()),
      )
      .subscribe();
  }
}
